export enum ProcessesTemplatesListTab {
  All = 'all',
  Published = 'published',
  Unpublished = 'unpublished',
}
